import {
  useRef, useEffect, RefObject, ReactNode,
} from 'react';
import styled from 'styled-components';

const OutsideClickerContainer = styled.div`
  width: 100%;
`;

function useOutsideAlerter(ref: RefObject<HTMLDivElement>, onClickOutside: () => void, ignoredEffectElements?: (HTMLElement | null)[], isCheckCurrentElements?: boolean) {
  useEffect(() => {
    function handleClickOutside(event: { target: any; }) {
      const shouldNotContainEventTarget = !ref?.current?.contains(event.target);
      const shouldNotContainInIgnoredElements = ignoredEffectElements?.every((e) => !e?.contains(event.target)) !== false;

      const isCheckCurrentElem = !isCheckCurrentElements
        ? shouldNotContainEventTarget && shouldNotContainInIgnoredElements
        : shouldNotContainInIgnoredElements;

      if (ref.current && isCheckCurrentElem) {
        onClickOutside();
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref.current, onClickOutside]);
}

export function OutsideClicker({
  onClickOutside,
  children,
  ignoredEffectElements,
  isCheckCurrentElements,
}: {
  onClickOutside: () => void,
  children: ReactNode,
  ignoredEffectElements?: (HTMLElement | null)[],
  isCheckCurrentElements?: boolean,
}) {
  const wrapperRef = useRef<HTMLDivElement>(null);
  useOutsideAlerter(wrapperRef, onClickOutside, ignoredEffectElements, isCheckCurrentElements);

  return <OutsideClickerContainer ref={wrapperRef}>{children}</OutsideClickerContainer>;
}
